export default __webpack_public_path__ + "static/media/Group9199.6a62d58d.svg";